<template>
  <div class="container-fluid first-view">
    <div class="background-overlay" v-if="tab === 'first'"></div>
    <action-alert
      :type="alert.type"
      :icon="alert.icon"
      :is-visible="alert.isVisible"
      >{{ alert.text }}</action-alert
    >
    <!--    <Breadcrumb :values="{ Home: '/', 'Top Worst': '' }"></Breadcrumb>-->
    <img class="logo" :src="logo" />
    <template v-if="searchFilters && searchFilters.metrics">
      <TopWorstFirstForm
        v-if="tab === 'first'"
        :form-data="formData"
        :searchFilters="searchFilters"
        @update:formData="formData = $event"
        @update:searchFilters="searchFilters = $event"
        :previous-page="previousPage"
        :next-page="nextPage"
      >
      </TopWorstFirstForm>
      <TopWorstSecondForm
        v-else-if="tab === 'second'"
        :form-data="formData"
        :fields="parsedFields"
        :searchFilters="searchFilters"
        @update:formData="formData = $event"
        @update:searchFilters="searchFilters = $event"
        :yearsObject="yearsObject"
        :previous-page="previousPage"
        :next-page="nextPage"
        @update-dropdown-values="updateDropdownValues"
      >
      </TopWorstSecondForm>
    </template>
  </div>
</template>

<script>
import _ from 'lodash'

import { mapActions, mapGetters } from 'vuex'

import TopWorstFirstForm from '../components/TopWorst/TopWorstFirstForm'
import TopWorstSecondForm from '../components/TopWorst/TopWorstSecondForm'
import ActionAlert from '../components/shared/ActionAlert'

import getInitialFilters from '../constants/searchFilters'
import studiesActions from '../store/modules/studies/actionTypes'
import generalActions from '../store/modules/general/actionTypes'
import generalGetters from '../store/modules/general/getterTypes'
import logo from '../assets/images/logos/Iris-Grey.svg'

export default {
  name: 'TopWorst',
  components: {
    ActionAlert,
    TopWorstFirstForm,
    TopWorstSecondForm
  },
  data () {
    return {
      formData: {
        radioDesc: 'best',
        radioPercentType: 'number',
        year: [],
        type: 'fragrances',
        rdfType: 'rdf'
      },
      searchFilters: {},
      parsedFields: {},
      tab: 'first',
      yearsObject: null,
      alert: {
        type: '',
        icon: '',
        text: '',
        isVisible: false
      },
      logo
    }
  },
  computed: {
    ...mapGetters({
      alertMessage: generalGetters.GET_ALERT_MESSAGE,
      alertType: generalGetters.GET_ALERT_TYPE
    })
  },
  methods: {
    ...mapActions({
      getAnalyticsFields: studiesActions.UPDATE_METRICS_DROPDOWN_OPTIONS,
      setOrClearFilters: studiesActions.SET_OR_CLEAR_SEARCH_FILTERS,
      toggleLoading: generalActions.TOGGLE_LOADING
    }),
    nextPage () {
      if (this.tab === 'first') {
        if (this.formData.radioDesc === 'best') {
          this.$set(this.searchFilters.metrics.threshold, 'desc', true)
        } else {
          this.$set(this.searchFilters.metrics.threshold, 'desc', false)
        }

        if (this.formData.rdfType === 'all') {
          this.searchFilters.metrics.metricsList.push({
            applyThreshold: false,
            threshold: { label: 'Threshold on metrics', key: 'threshold', value: { amount: 10, desc: true, type: '' } },
            metricType: { label: 'Metric type', key: 'metric_type', value: '' },
            metric: { label: 'Metric', key: 'metric', value: '' },
            aggregation: { label: 'Aggregation', key: 'aggregation', value: '' },
            confidence: { label: 'Confidence', key: 'confidence', value: false }
          })
        }

        if (this.formData.rdfType === 'rdf') {
          this.$set(this.searchFilters.metrics.metricsList[0].aggregation, 'value', 'top_2_box')
        } else if (this.formData.rdfType === 'eeg') {
          this.$set(this.searchFilters.metrics.metricsList[0].aggregation, 'value', 'mean')
        } else if (this.formData.rdfType === 'all') {
          this.$set(this.searchFilters.metrics.metricsList[0].aggregation, 'value', 'top_2_box')
          this.$set(this.searchFilters.metrics.metricsList[1].aggregation, 'value', 'mean')
        }

        if (this.formData.radioPercentType === 'number') {
          this.$set(this.searchFilters.metrics.threshold, 'type', 'fragrances')
        } else {
          this.$set(this.searchFilters.metrics.threshold, 'type', 'percentage')
        }
        this.$set(this.searchFilters.metrics.rdfType, 'value', this.formData.rdfType)
        this.tab = 'second'
      } else if (this.tab === 'second') {
        this.$set(this.searchFilters.metrics.threshold, 'applyThreshold', true)
        this.$set(this.searchFilters.metrics.metricsList[0].metricType, 'value', 'Performance')

        if (this.formData.rdfType === 'rdf') {
          this.$set(this.searchFilters.metrics.metricsList[0].metric, 'value', 'liking')
        } else if (this.formData.rdfType === 'eeg') {
          this.$set(this.searchFilters.metrics.metricsList[0].metric, 'value', 'hfd_hedonic')
        } else if (this.formData.rdfType === 'all') {
          this.$set(this.searchFilters.metrics.metricsList[1].metricType, 'value', 'Performance')
          this.$set(this.searchFilters.metrics.metricsList[0].metric, 'value', 'liking')
          this.$set(this.searchFilters.metrics.metricsList[1].metric, 'value', 'hfd_hedonic')
        }
        this.handleSearch()
      }
    },
    previousPage () {
      if (this.tab === 'third') {
        this.tab = 'second'
      } else if (this.tab === 'second') {
        this.tab = 'first'
      }
    },
    handleSearch () {
      this.setOrClearFilters({ 'clearFilters': false, filters: this.searchFilters })
    },
    parseFields (fields) {
      const seekingFields = ['Business Unit', 'Category', 'Client', 'Product Type', 'Region', 'Year']
      const collectedFields = {}

      const data = fields[0]['data']
      for (let i = 0; i < data.length; ++i) {
        if (seekingFields.includes(data[i].label)) {
          if (data[i].type === 'category') {
            const options = []
            for (let j = 0; j < data[i].options.length; ++j) {
              let { count, value } = data[i].options[j]
              if (data[i].label === 'Year') value = parseInt(value)
              options.push([value, count])
            }

            collectedFields[data[i].label] = options
          }
        }
      }
      this.parsedFields = collectedFields
    },
    updateDropdownValues (values) {
      this.parseFields(values)
    }
  },
  async beforeMount () {
    if (!this.searchFilters.length) {
      this.toggleLoading(true)
      const analyticFields = (await this.getAnalyticsFields({ query: [], query_metrics: [] })).data.fields
      this.parseFields(analyticFields)
      const years = [...this.parsedFields['Year']]
      const [firstYear, lastYear] = [years[0][0], years[years.length - 1][0]]
      this.formData.year = [String(firstYear), String(lastYear)]
      this.yearsObject = {
        min: firstYear,
        max: lastYear,
        marks: { [firstYear]: String(firstYear), [lastYear]: String(lastYear) }
      }

      this.searchFilters = _.cloneDeep(getInitialFilters.getInitialFilters())
      this.toggleLoading(false)
    }
  }
}
</script>
<style lang="scss" scoped>
.container-fluid.first-view {
  padding: 99px 87px !important;
  background-image: url("../assets/images/backgrounds/IRIS-background-720p.jpg");
  background-position: center;
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;
  .background-overlay {
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: #2a274b;
    opacity: 0.4;
  }
}

.container-fluid {
  height: 100%;
}

.logo {
  position: fixed;
  bottom: 60px;
  right: 25px;
  max-width: 300px;
  min-width: 120px;
  max-height: 300px;
  min-height: 120px;
  width: 10%;
  height: auto;
}
@media (max-height: 980px) {
  .logo {
    bottom: 40px;
    right: 15px;
    width: 6%;
  }
}
</style>
